export default __webpack_public_path__ + "2f61e894dca700f17487c90addebc181.png";